import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputRoutingModule } from './input-routing.module';
import { InputGroupComponent } from './inputGroup.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {InputTextModule} from "../../component/ing/inputtext/inputtext";
import {TableModule} from "../../component/ing/table/table";
import {ButtonModule} from "../../component/ing/button/button";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    InputRoutingModule,
    InputTextModule,
    TableModule,
    ButtonModule
  ],
  declarations: [InputGroupComponent]
})
export class InputGroupDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/inputGroup/inputGroupDemo.module.ts